// frontend/src/components/ProgressBar.js
import React from 'react';

function ProgressBar({ unlocked, total }) {
  const percent = total > 0 ? Math.round((unlocked / total) * 100) : 0;
  const width = Math.min(Math.max(percent, 0), 100);

  const getProgressColor = (p) => {
    if (p === 100) return '#4CAF50';
    if (p >= 75) return '#8BC34A';
    if (p >= 50) return '#FF9800';
    if (p >= 25) return '#2196F3';
    return '#f44336';
  };

  return (
    <div className="progress-container" aria-label="Прогресс маршрута">
      <div className="progress-header" style={{ justifyContent: 'space-between' }}>
        <span className="progress-title">Прогресс маршрута</span>
        <span className="progress-counter">{unlocked}/{total} · {percent}%</span>
      </div>
      <div 
        className="progress-bar" 
        role="progressbar" 
        aria-valuemin={0} 
        aria-valuemax={100} 
        aria-valuenow={percent}
        aria-valuetext={`${percent}%`}
      >
        <div 
          className="progress-fill" 
          style={{ 
            width: `${width}%`,
            backgroundColor: getProgressColor(percent),
            transition: 'width 0.5s ease-in-out'
          }}
        />
      </div>
    </div>
  );
}

export default ProgressBar;